import React, { useCallback, useLayoutEffect, useReducer, useRef, useState } from 'react';
import { Box, Popover, Stack } from '@mui/material';
import { classes } from './styles';
import TabSelector from './Tabs/TabSelector';
import TabPanel from './Tabs/TabPanel';
import Searches from './Searches/Searches';
import CandidatePools from './CandidatePools/CandidatePools';
import CandidateSourcingEmailAnalytics from './CandidatePools/CandidateSourcingEmailAnalytics';
import {
  candidateSourcingReducer,
  initialCandidateSourcingState
} from './candidateSourcingReducer';
import CreateButton from '../Components/Buttons/CreateButton';

const CandidateSourcing = () => {
  const [candidateSourcingState, candidateSourcingDispatch] = useReducer(
    candidateSourcingReducer,
    initialCandidateSourcingState
  );
  const tabIndicatorRef = useRef<HTMLElement[]>([]);
  const [actionsAnchorEl, setActionsAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleTabChange = useCallback((event: React.SyntheticEvent, tabValue: number) => {
    candidateSourcingDispatch({ type: 'SET_SELECTED_TAB', payload: tabValue });
  }, []);

  const handleCreateNewSearch = () => {
    window.location.href = '/admin/candidate_sourcing/searches/new';
  };

  const handleCreateNewPool = () => {
    // TODO: Implement create new pool functionality
  };

  useLayoutEffect(() => {
    candidateSourcingDispatch({
      type: 'SET_INDICATOR_WIDTH',
      payload: tabIndicatorRef?.current[candidateSourcingState.selectedTab]?.clientWidth || 0
    });
  }, [candidateSourcingState.selectedTab]);

  return (
    <Box sx={classes.pageContainer}>
      {candidateSourcingState.selectedEmailForAnalytics ? (
        <CandidateSourcingEmailAnalytics
          selectedEmail={candidateSourcingState.selectedEmailForAnalytics}
          emailsDispatch={candidateSourcingDispatch}
          selectedPoolId={candidateSourcingState.selectedEmailForAnalytics.poolId}
        />
      ) : (
        <>
          <Box sx={classes.pageHeader}>
            <h1>Agentic :ENGAGE</h1>
            <CreateButton
              id="new-search-button"
              ariaLabel="new search"
              onClick={(e) => {
                setActionsAnchorEl(e.currentTarget);
              }}
              isOpen={Boolean(actionsAnchorEl)}
            />
            <Popover
              open={Boolean(actionsAnchorEl)}
              anchorEl={actionsAnchorEl}
              onClose={() => {
                setActionsAnchorEl(null);
              }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{ '& .MuiPaper-root': { marginTop: '12px', borderRadius: '6px' } }}
            >
              <Stack sx={classes.createNewPopover}>
                <Stack onClick={handleCreateNewSearch} id="create-search-button">
                  New Search
                </Stack>
                <Stack onClick={handleCreateNewPool} id="create-candidate-pool-button">
                  New Candidate Pool
                </Stack>
              </Stack>
            </Popover>
          </Box>
          <TabSelector
            candidateSourcingState={candidateSourcingState}
            handleTabChange={handleTabChange}
            tabIndicatorRef={tabIndicatorRef}
          />
          <TabPanel tabValue={candidateSourcingState.selectedTab} index={0}>
            <Searches />
          </TabPanel>
          <TabPanel tabValue={candidateSourcingState.selectedTab} index={1}>
            <CandidatePools candidateSourcingDispatch={candidateSourcingDispatch} />
          </TabPanel>
        </>
      )}
    </Box>
  );
};

export default CandidateSourcing;
